import OrdersHistorySection from 'components/revelo-ui/account/details/order-history';
import AddressesSection from './addresses';
import GeneralSection from './general';
import SecuritySection from './security';

export { GeneralSection, SecuritySection, AddressesSection, OrdersHistorySection };
